import { render } from "./SatisfactionHeatmap.vue?vue&type=template&id=3963d8e4&scoped=true"
import script from "./SatisfactionHeatmap.vue?vue&type=script&lang=js"
export * from "./SatisfactionHeatmap.vue?vue&type=script&lang=js"

import "./SatisfactionHeatmap.vue?vue&type=style&index=0&id=3963d8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3963d8e4"]])

export default __exports__